import { render, staticRenderFns } from "./TaxonomyParent.vue?vue&type=template&id=2a569f3e&"
import script from "./TaxonomyParent.vue?vue&type=script&lang=ts&"
export * from "./TaxonomyParent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports